/** Floating instruction label for training clips. Import, never remake. */

import { useCurrentFrame, interpolate } from "remotion";

interface StepLabelProps {
  text: string;
  show: number;
  hide: number;
  color?: string;
}

export function StepLabel({ text, show, hide, color = "#3b82f6" }: StepLabelProps) {
  const frame = useCurrentFrame();
  if (frame < show - 1 || frame >= hide + 1) return null;

  const enter = interpolate(frame, [show, show + 8], [0, 1], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });
  const exit = interpolate(frame, [hide - 8, hide], [1, 0], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });
  const opacity = Math.min(enter, exit);
  const y = interpolate(enter, [0, 1], [10, 0]);

  return (
    <div
      style={{
        position: "absolute",
        bottom: 48,
        left: "50%",
        transform: `translateX(-50%) translateY(${y}px)`,
        background: "rgba(10,10,11,0.94)",
        borderLeft: `3px solid ${color}`,
        padding: "14px 32px 14px 20px",
        backdropFilter: "blur(12px)",
        zIndex: 100,
        opacity,
        whiteSpace: "nowrap",
      }}
    >
      <span
        style={{
          fontSize: 18,
          fontWeight: 600,
          color: "#e4e4e7",
          fontFamily: "'Inter', sans-serif",
        }}
      >
        {text}
      </span>
    </div>
  );
}
